export default __webpack_public_path__ + "static/media/business-card.8b2768e5.png";